/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
// eslint-disable-next-line react/prop-types
function Notes({ width = 21, height = 22, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      fill="#000000"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 479.999 479.999"
      xmlSpace="preserve"
      {...props}
    >
      <g>
        <g>
          <g>
            <path
              d="M67.021,181.568h182.487c5.522,0,10-4.478,10-10c0-5.523-4.477-10-10-10H67.021c-5.522,0-10,4.477-10,10
				S61.499,181.568,67.021,181.568z"
            />
            <path
              d="M67.021,227.194h182.487c5.522,0,10-4.478,10-10c0-5.522-4.477-10-10-10H67.021c-5.522,0-10,4.478-10,10
				C57.021,222.717,61.499,227.194,67.021,227.194z"
            />
            <path
              d="M208.193,262.82c0-5.522-4.478-10-10-10H67.021c-5.522,0-10,4.478-10,10c0,5.522,4.478,10,10,10h131.172
				C203.716,272.82,208.193,268.343,208.193,262.82z"
            />
            <path
              d="M477.436,192.45l-64.396-71.628c-3.693-4.108-10.016-4.442-14.121-0.752l-47.73,42.901
				c-0.003,0.003-0.006,0.005-0.009,0.008l-34.651,31.156v-79.588c0-3.086-1.425-5.999-3.86-7.894L210.03,26.813
				c-0.111-0.087-0.229-0.163-0.343-0.245c-0.095-0.066-0.186-0.137-0.283-0.201c-0.182-0.121-0.37-0.23-0.559-0.339
				c-0.145-0.083-0.291-0.16-0.44-0.236c-0.181-0.091-0.36-0.182-0.546-0.262c-0.132-0.058-0.268-0.106-0.402-0.157
				c-0.146-0.056-0.291-0.111-0.438-0.16c-0.141-0.046-0.282-0.086-0.425-0.126c-0.154-0.044-0.309-0.083-0.465-0.119
				c-0.137-0.031-0.273-0.062-0.411-0.087c-0.183-0.033-0.367-0.06-0.552-0.084c-0.116-0.015-0.23-0.032-0.348-0.043
				c-0.306-0.028-0.613-0.047-0.922-0.047c0,0-0.004,0-0.005,0h-0.001h-0.038H10c-5.523,0-10,4.478-10,10v410.586
				c0,5.522,4.477,10,10,10h296.529c5.522,0,10-4.478,10-10v-94.726l112.398-101.088c0.002-0.002,0.004-0.004,0.006-0.006
				l47.75-42.899c1.973-1.772,3.161-4.257,3.302-6.906C480.127,197.019,479.21,194.423,477.436,192.45z M282.61,108.611
				l-68.403,9.737l-0.238-63.133L282.61,108.611z M20,435.293V44.707h173.928l0.322,85.197c0.011,2.891,1.273,5.637,3.46,7.527
				c1.829,1.58,4.154,2.435,6.54,2.435c0.468,0,0.939-0.033,1.409-0.1l90.87-12.935v85.286L207.94,291.77
				c-0.143,0.128-0.268,0.267-0.402,0.4c-0.077,0.077-0.157,0.15-0.232,0.23c-0.271,0.29-0.524,0.592-0.754,0.905
				c-0.001,0.001-0.002,0.002-0.002,0.002c-0.232,0.319-0.438,0.65-0.629,0.988c-0.043,0.076-0.082,0.154-0.123,0.231
				c-0.15,0.285-0.287,0.575-0.408,0.87c-0.021,0.052-0.05,0.098-0.07,0.15l-39.419,100.25c-1.386,3.524-0.661,7.53,1.872,10.347
				c1.924,2.139,4.64,3.313,7.436,3.313c0.885,0,1.777-0.117,2.655-0.359l103.814-28.608c0.007-0.002,0.014-0.005,0.02-0.007
				c0.37-0.103,0.73-0.231,1.086-0.376c0.093-0.038,0.184-0.08,0.274-0.12c0.277-0.122,0.548-0.257,0.813-0.404
				c0.079-0.043,0.159-0.084,0.236-0.129c0.325-0.192,0.641-0.401,0.944-0.63c0.048-0.037,0.092-0.078,0.14-0.115
				c0.175-0.138,0.351-0.273,0.518-0.424l10.819-9.73v66.739H20z M218.01,317.93l19.208,21.37l23.556,26.206l-68.94,18.997
				L218.01,317.93z M279.772,356.725l-38.306-42.618l-12.719-14.149L357.115,184.54l17.011,18.928l33.995,37.825L279.772,356.725z
				 M422.995,227.923l-27.464-30.558l-23.543-26.196l32.864-29.54l51.023,56.754L422.995,227.923z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
export default Notes;
